import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { fetchTrends } from "../api/api";

const TrendingTags = () => {
  const [trends, setTrends] = useState([]);

  useEffect(() => {
    const loadTrends = async () => {
      const data = await fetchTrends();
      if (data && data.trends) {
        const trendQueries = data.trends.map((trend) => trend.title);
        setTrends(trendQueries);
      }
    };

    loadTrends();
  }, []);

  return (
    <>
      <Helmet>
        <title>
        {/* What that means next level access... */}
        What that means next level access...
          {/* {trends.length > 0
           ?"What that means next level access..." : `Trending: ${trends[0]}`
            } */}
        </title>
        <meta
          name="description"
          content="What That Means provides you with life-improvement gifts and genius hacks that rapidly improve your health, wealth & happiness."
          // content={`Learn about ${trends.join(", ")} and more trending topics.`}
        />
        <meta name="keywords" content={trends.join(", ")} />
      </Helmet>
    </>
  );
};

export default TrendingTags;
